import { render, staticRenderFns } from "./TestArea.vue?vue&type=template&id=88cb2052&"
import script from "./TestArea.vue?vue&type=script&lang=js&"
export * from "./TestArea.vue?vue&type=script&lang=js&"
import style0 from "./TestArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports